import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    fileTypeIs: string;
    uploaderIs: ({ name }: {
        name: string;
    }) => string | React.ReactNode;
    statusIs: string;
    sourceFilenameIs: string;
    formatIs: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Section title for suggested searches */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestedSearches.title?c=2bzpi29t78zr8", defaultMessage: "Suggestions" }));
                },
                enumerable: true,
                configurable: true
            },
            /** @notranslate */
            fileTypeIs: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestedSearches.fileTypeIs?c=1h713y2ngz3", defaultMessage: "File Type is audio" }));
                },
                enumerable: true,
                configurable: true
            },
            /** @notranslate */
            uploaderIs: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                        name: string;
                    }) => __intl__.intl().formatMessage({ id: "SuggestedSearches.uploaderIs?c=1g10zvht7z71c", defaultMessage: "Uploader is {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** @notranslate */
            statusIs: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestedSearches.statusIs?c=3nlo84oi2kmdz", defaultMessage: "Status is needs review" }));
                },
                enumerable: true,
                configurable: true
            },
            /** @notranslate */
            sourceFilenameIs: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestedSearches.sourceFilenameIs?c=2jnhc1thiyni1", defaultMessage: "Source Filename is asset-v3.tiff" }));
                },
                enumerable: true,
                configurable: true
            },
            /** @notranslate */
            formatIs: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SuggestedSearches.formatIs?c=39417o8luir9d", defaultMessage: "Format is PDF" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
